<template lang="pug">
  .container-trackings-welivery
    .container-tracking-welivery(v-for="(order, index) in tracking" :key="index" :class="{'page-break': index !== 0}" v-if="getDelivery(order).idWelivery")
      .container-tracking
        .container-tracking-data-welivery
          // .delivery-text Entrega
          .destination-text Destinatario
          .destination-address {{ order.address }}
          .destination-detail Sin Detalle
          .destination-name.capitalize {{ order.name }}
          .destination-phone {{ order.phones[0] }}
          .line-welivery
          // .welivery-text Welivery
          .company-id-text ID Envío de Cliente
          .welivery-id.client-reference {{ getDelivery(order).weliveryReference || order.order }}
          .welivery-barcode
            VueBarcode(:value="getDelivery(order).idWelivery" format="code128" :width="2" :height="26" :displayValue="false" :margin="3")
          .company-id Welivery ID: {{ '#' + getDelivery(order).idWelivery }}
          .welivery-package(v-if="order.packageCount > 1") Paquete {{ order.packageNumber }} de {{ order.packageCount }}
          .destination-cp CP1 / {{ community(order) }}
          .welivery-car-number Nro. de Carro XXX
          .destination-visits
            .visit
              span 1° Visita
              span.square
            .visit
              span 2° Visita
              span.square
            .visit
              span Devolución
              span.square
          .welivery-creation
            span Fecha de Creación:
            strong.welivery-creation-date {{ date(getDelivery(order).dateWelivery) }}
          .line-welivery
          // .company-name Sahet
          // .company-text Remitente
          // .company-address Calle 37B sur # 68i 23 Piso 1 - Kennedy - 1
          //.line-welivery
          // .welivery-container-footer
            QRCode(text="https://www.welivery.lat" width="30" margin="0" scale="5" :small="true")
            .text-welivery
              div Welivery entregó tu compra
              div Seguinos en nuestras redes
</template>

<script>
import VueBarcode from 'vue-barcode'
import QRCode from '@/components/elements/QRCode.vue'
import mFilters from '@/mixins/filters'

export default {
  components: { VueBarcode, QRCode },

  mixins: [mFilters],

  methods: {
    getDelivery (order) {
      if (order.deliveries.length === 0) return {}
      return order.deliveries.at(-1)
    },
    community (order) {
      if (order.location === 'soacha') return 'soacha'

      const community = order.community
      if (!community) return '-'
      if (community === 'no conozco la localidad') return '-'
      return community
    },
    isChange (order) {
      if (order.order[0] === 'c') return true
      return false
    }
  },

  computed: {
    tracking () {
      const token = this.$route.query.batch
      if (!token) return this.$store.state.trackingDeliveries
      try { return JSON.parse(sessionStorage.getItem('welivery-print-' + token) || '[]') } catch (error) { return [] }
    }
  }
}
</script>

<style lang="stylus" scoped>
width = 99mm
height = 99mm
font-size-super-small = 2mm
font-size-small = 3mm
font-size-medium = 3.5mm

.container-tracking-welivery
  font-family 'Tahoma', sans-serif
  width width
  height height
  border .5mm solid #000
  display flex
  flex-direction column
  align-items center
  justify-content center
  padding 0
  color #000

.container-tracking
  display flex
  width 100%

.container-data-company
  border-left .5mm solid #000
  flex-basis 12mm
  flex-shrink 0
  width 12mm

.company-data-text
  transform-origin 0 0
  transform rotate(90deg) translateY(-11mm) translateX(2mm)
  width width
  font-weight bold
  text-align left
  font-size font-size-medium
  display flex
  flex-direction column
  gap 1mm

.container-tracking-data-welivery
  display flex
  flex-direction column
  align-items center
  justify-content center
  width 100%
  padding 3mm
  flex-shrink 0

.line-welivery
  width 100%
  max-width width
  border-bottom .5mm solid #000
  margin 1.5mm 0

.delivery-text
  font-size font-size-super-small

.destination-text
  font-size font-size-small
  font-weight bold
  margin-top 1mm

.destination-address
  text-transform uppercase
  font-size font-size-small
  margin-top 2mm
  font-weight bold

.destination-detail
  font-size font-size-super-small

.destination-name
  font-size font-size-small
  margin-top 2mm
  font-weight bold

.destination-phone
  font-size font-size-small
  margin-top 0mm
  font-weight bold

.welivery-text
  font-size font-size-small
  font-weight bold

.company-id-text
  font-size font-size-super-small
  margin-top 1mm

.company-id
  font-size font-size-small
  margin-bottom 2mm

.welivery-id
  font-size font-size-small
  font-weight bold

.client-reference
  margin-top 1mm

.destination-cp
  font-size font-size-super-small
  margin-top 2mm

.welivery-car-number
  font-size font-size-super-small
  margin-top 2mm
  font-weight bold

.destination-visits
  display flex
  flex-direction row
  align-items center
  justify-content center
  font-size font-size-super-small
  margin-top 2mm
  gap 2mm

.visit
  display flex
  flex-direction row
  align-items center
  justify-content center
  gap 1mm

.visit .square
  display inline-block
  width 2mm
  height 2mm
  border 1px solid #000

.welivery-creation
  font-size font-size-super-small
  margin-top 2mm
  font-weight normal

.welivery-creation-date
  margin-left 1mm
  font-size font-size-small
  font-weight bold

.company-name
  font-size 2mm

.company-text
  font-size 2mm
  margin-top 2mm
  font-weight bold

.company-address
  font-size 2.5mm
  font-weight bold

.text-welivery
  font-size 2.5mm
  text-align left

.welivery-container-footer
  display flex
  flex-direction row
  align-items center
  justify-content center
  gap 2mm

.text-welivery div:nth-child(2)
  font-size 2mm

.page-break
  break-inside avoid

@media print
  *
    margin 0
    padding 0
  .container-trackings-welivery
    display block
  .container-tracking-welivery
    border none
</style>



// WEBPACK FOOTER //
// src/components/pages/order/mass/TrackingDelivery.vue